import type {ReactElement} from 'react';
import React from 'react';
import styles from './spam-mailing-list-controls.module.scss';
import type {UserMailingList} from '@Components/email-marketing-campaign-performance/email-marketing-campaign-performance.types';
import {ClickableDiv} from '@Components/clickable-div';
import {Icon} from '@Components/icon-v2';
import {IconSize, IconType} from '@Components/icon-v2/icon.types';

export interface SpamMailingListControlsProps {
  mailingList: UserMailingList;
  onClickDelete: VoidFunction;
  onClickSpamInfo: VoidFunction;
  iconWrapperClass?: string;
}

export default function SpamMailingListControls({mailingList, onClickDelete, onClickSpamInfo, iconWrapperClass = ''}: SpamMailingListControlsProps): ReactElement<any> {
  return (
    <>
      <ClickableDiv onClick={onClickSpamInfo} className={`${iconWrapperClass} _full-height`}>
        <Icon className={styles.infoIcon} type={IconType.SECONDARY} size={IconSize.SIZE_ICON_20} icon={'icon-info'} />
      </ClickableDiv>
      <ClickableDiv onClick={onClickDelete} className={`${iconWrapperClass} _full-height`}>
        <Icon className={`${styles.infoIcon} ${styles.delete}`} type={IconType.SECONDARY} size={IconSize.SIZE_ICON_20} icon={'icon-delete'} />
      </ClickableDiv>
    </>
  );
}
